import { createSelector } from 'reselect'
import State from 'reducks/store/types'

const chapterSelector = (state: State) => state.chapters

export const getChapterItems = createSelector([chapterSelector], (state) => state)
